module.exports = __webpack_public_path__ + "static/media/6820.8c9878d5.jpg";